import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import Button, { ButtonType } from 'components/Button';
import { RoutePath } from 'enums/Routes';
import { CurrentFlow } from 'enums/CurrentFlow';
import { useNavigate } from 'hooks/useNavigate';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import { getApplicationData } from 'selectors/getApplicationData';
import { updateApplicationCurrentFlow } from 'thunks';

import styles from './ConnectAccountsSection.module.scss';

const ConnectAccountsSection: React.FC = () => {
  const navigate = useNavigate();
  const dispatchWithUnwrap = useDispatchWithUnwrap();
  const { application } = useSelector(getApplicationData);
  const [isSwitchingFlow, setIsSwitchingFlow] = useState(false);

  const handleConnectAccountsClick = async () => {
    analytics.track('Dashboard Connect Accounts Clicked');

    if (application && application.currentFlow !== CurrentFlow.AICoach) {
      setIsSwitchingFlow(true);
      try {
        await dispatchWithUnwrap(
          updateApplicationCurrentFlow({
            applicationId: application.id,
            currentFlow: CurrentFlow.AICoach,
          }),
        );
      } finally {
        setIsSwitchingFlow(false);
      }
    }

    navigate(RoutePath.PlaidCheckingAccounts);
  };

  return (
    <div className={styles.connectAccountsSection}>
      <div className={styles.copy}>
        <h3 className={styles.title}>Connect accounts to track your progress</h3>
        <p className={styles.description}>
          Connect to your accounts and we&apos;ll track your progress toward your goal. If you start falling behind,
          we&apos;ll show you simple ways to catch up.
        </p>
      </div>
      <Button
        type={ButtonType.Secondary}
        className={styles.connectButton}
        onClick={handleConnectAccountsClick}
        isLoading={isSwitchingFlow}
      >
        CONNECT ACCOUNTS
      </Button>
    </div>
  );
};

export default ConnectAccountsSection;
